/**
 * 配置编译环境和线上环境之间的切换
 *
 * PROCESS_ENV：当前环境
 * BASE_URL: 接口域名地址
 * BASE_HREF: 基础路径
 * SHARE_URL：分享地址
 * ROUTER_MODE: 路由模式
 * IMG_BASE_URL: 图片所在域名地址
 *
 */
let PROCESS_ENV = process.env.VUE_APP_ENV
let BASE_URL = process.env.VUE_APP_API_BASE
let BASE_HREF = process.env.VUE_APP_HREF_BASE
let SHARE_URL = process.env.VUE_APP_SHARE_URL
// let ROUTER_MODE = "history";
let ROUTER_MODE = ''
let IMG_BASE_URL = 'http://youp-read.leqilucky.com'
let CONTACT_URL = 'http://xiaokefu.com.cn/s/93nr53'
let UN_SEARCH_MODE = 'auto' // 免搜商品的录入模式; auto: 自动; manual: 手动。

export {
  PROCESS_ENV,
  BASE_URL,
  BASE_HREF,
  SHARE_URL,
  ROUTER_MODE,
  IMG_BASE_URL,
  CONTACT_URL,
  UN_SEARCH_MODE
}
